import axios from 'axios'
import store from '../store';

export default {
    get: (filters) => axios.post('events',filters),
    show: (id) => axios.get('events/show/'+id),
    getSimpleList: () => axios.get('events/simple-list'),
    getTicketsMetrick: (id) => axios.get('events/'+id+'/metrics/tickets'),
    getMetrickGraphs: (id) => axios.get('events/'+id+'/metrics/graphs'),
    store: (data) => axios.post('events/store', data),
    update: (data) => axios.post('events/update', data),
    delete: (id) => axios.post('events/delete', id),
    downloadExcel: (filters) => axios.post('events/download-excel',filters).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),
    downloadPdf: (data) => axios.post('events/download-pdf',data).then(function(response){
        if(response.type == "success"){
            window.open(response.data, '_blank');
        }
        else{
            store.commit('toast', {color: response.type, message: response.message});
        }
    }),

    //Eventos externos
    getExternalEvent: (slug, code) => axios.get(`events/external/${slug}/${code}`),
    storeExternalGuest: (data) => axios.post('events/external/guest', data)


}